import { render, staticRenderFns } from "./add.modal.vue?vue&type=template&id=bd32b6d6&"
import script from "./add.modal.vue?vue&type=script&lang=js&"
export * from "./add.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports